import { supabase } from './supabase';
import { Message } from '@/types/chat';

export interface LeadSubmissionInput {
  fullName: string;
  phone: string;
  contactMethod?: 'phone' | 'whatsapp';
  preferredTime?: 'morning' | 'noon' | 'afternoon' | 'evening';
  courseId?: string;
  courseName?: string;
  mentorId?: string;
  mentorName?: string;
  mentorEmail?: string;
  source?: string;
  submittedAt?: string;
  messages?: Message[];
  leadGate?: Record<string, unknown>;
  [key: string]: unknown;
}

class LeadSubmissionService {
  async submitLead(payload: LeadSubmissionInput): Promise<{ success: boolean; error?: string }> {
    const cleanPhone = (payload.phone || '').replace(/\D/g, '');
    const normalizedPhone = cleanPhone.startsWith('0') ? cleanPhone : `0${cleanPhone}`;
    const submittedAt = payload.submittedAt || new Date().toISOString();
    const selectedCourseName = payload.courseName || 'הקורס שבחרת';

    try {
      const { error } = await supabase.functions.invoke('submit-lead', {
        body: {
          leadData: {
            ...payload,
            phone: normalizedPhone,
            submittedAt,
          },
          messages: payload.messages || [],
          confirmation: {
            channel: 'webhook',
            template: 'lead_received_24h',
            message: `קיבלנו את הבקשה שלך ב-KURSI. נחזור אליך תוך 24 שעות לגבי ${selectedCourseName}.`,
            courseName: payload.courseName || null,
            submittedAt,
          },
        },
      });

      if (error) {
        console.error('[LeadSubmissionService] submit-lead function failed, fallback to direct insert:', error);
        await this.fallbackInsert(payload, normalizedPhone);
      }

      return { success: true };
    } catch (err) {
      console.error('[LeadSubmissionService] submit-lead exception, fallback to direct insert:', err);
      try {
        await this.fallbackInsert(payload, normalizedPhone);
        return { success: true };
      } catch (fallbackErr: any) {
        return {
          success: false,
          error: fallbackErr?.message || 'Lead submission failed',
        };
      }
    }
  }

  private async fallbackInsert(payload: LeadSubmissionInput, normalizedPhone: string): Promise<void> {
    const { error } = await supabase.from('leads').insert({
      full_name: payload.fullName,
      phone: normalizedPhone,
      course_id: payload.courseId || null,
      message: payload.mentorName
        ? `Contact method: ${payload.contactMethod || 'phone'}, Preferred time: ${payload.preferredTime || 'evening'}`
        : undefined,
      status: 'new',
      source: payload.source || 'website',
    });

    if (error) throw error;
  }
}

export const leadSubmissionService = new LeadSubmissionService();
